import {Avatar, Drawer, List} from 'antd';
import moment from 'moment';
import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import useFetch, {CachePolicies} from "use-http";
import _ from "lodash";
import Comment from "../Comment";
import {getUserData} from "../../../service/auth.service";
import CommentToolbar from "../../../pages/Home/Post/CommentToolbar";
import {getPathWss} from "../../../service/util.service";
import {ReconnectDuration} from "../../../constants/WebSocket";

const data = [
    {
        // actions: [<span key="comment-list-reply-to-0">Reply to</span>, <span>{moment().subtract(1, 'days').fromNow()}</span>],
        // author: <div style={{ backgroundColor: "#F5F5F5"}}>'Han Solo'</div>,
        avatar: <Avatar size={40} src="https://joeschmoe.io/api/v1/random"/>,
        content: (
            <Fragment>
                <div style={{padding: ".75rem 1.5rem", borderRadius: "12px", backgroundColor: "#F5F5F5"}}>
                    <p style={{fontWeight: "bold", backgroundColor: "#F5F5F5", marginBottom: ".75rem"}}>Han Solo</p>
                    <span>
                        We supply a series of design principles, practical patterns and high quality design
                        resources (Sketch and Axure), to help people create their product prototypes beautifully and
                        efficiently.
                    </span>
                </div>
                <div>
                    <span style={{fontSize: "12px", color: "#BEBEBE"}}>{moment().subtract(1, 'days').fromNow()}</span>
                </div>
            </Fragment>
        ),
        // datetime: (
        //     <Tooltip title={moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')}>
        //         <span>{moment().subtract(1, 'days').fromNow()}</span>
        //     </Tooltip>
        // ),
    },
    {
        avatar: 'https://joeschmoe.io/api/v1/random',
        content: (
            <Fragment>
                <div style={{padding: ".75rem 1.5rem", borderRadius: "12px", backgroundColor: "#F5F5F5"}}>
                    <p style={{fontWeight: "bold", backgroundColor: "#F5F5F5", marginBottom: ".75rem"}}>Han Solo</p>
                    <span>
                        We supply a series of design principles, practical patterns and high quality design
                        resources (Sketch and Axure), to help people create their product prototypes beautifully and
                        efficiently.
                    </span>
                </div>
                <div>
                    <span style={{fontSize: "12px", color: "#BEBEBE"}}>{moment().subtract(1, 'days').fromNow()}</span>
                </div>
            </Fragment>
        ),
    },
];

interface CommentsDrawerProps {
    feedId: string | undefined
    open: boolean
    onClose: () => void
}

export const CommentsDrawer: React.FunctionComponent<CommentsDrawerProps> = (props) => {
    const [comments, setComments] = useState<any[]>([]);

    const [wsCommentMsg, setWsCommentMsg] = useState<any>(null);
    const [wsComment, setWsComment] = useState<any>(null);

    const [currentCommentId, setCurrentCommentId] = useState<string>();

    const isDestroy = useRef<boolean>();

    const commentInputRef: any = useRef<HTMLInputElement>(null);

    const loadCommentAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/comment/${props.feedId}?limit=-1`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const loadComment = async () => {
        const res = await loadCommentAPI.get();
        if (loadCommentAPI.response.ok) {
            setComments(res?.comments ? res?.comments : []);
        }
    };

    useEffect(() => {
        if (!props.feedId) {
            setComments([]);
            setCurrentCommentId("");
        } else {
            loadComment();
        }
    }, [props.feedId]);

    function connect(socketUrl: string) {
        let webSocket = new WebSocket(socketUrl);
        webSocket.onopen = () => {
            console.log(":: comment connected");
        };
        webSocket.onclose = (e: any) => {
            console.log(":: comment closed", e.reason);
            if (isDestroy.current) return;
            setTimeout(() => {
                connect(socketUrl);
            }, ReconnectDuration);
        };
        webSocket.onmessage = (msg: any) => {
            console.log("msg:", msg);
            let m = JSON.parse(msg.data);
            setWsCommentMsg(m);
        };
        console.log("webSocket:", webSocket);
        setWsComment(webSocket);
    }

    useEffect(() => {
        if (props.feedId) {
            isDestroy.current = false;

            const socketUrl = `${getPathWss(
                window.__RUNTIME_CONFIG__.REACT_APP_COMMENT_CENTER_WS
            )}/?id=${props?.feedId}`;

            if (!isDestroy.current) {
                connect(socketUrl);
            }
        } else {
            if (wsComment) {
                wsComment.close();
                isDestroy.current = true;
                console.log(":: comment is closed now");
            }
        }
    }, [props?.feedId]);

    useEffect(() => {
        if (wsCommentMsg) {
            if (wsCommentMsg?.body?.res) {
                setComments((prevComment: any[]) => [...prevComment, wsCommentMsg?.body?.res]);
            }
        }
    }, [wsCommentMsg]);

    const onLike = (commentId: string) => {
        setComments((prevComments: any[]) => {
            let newComments = [...prevComments];
            let commentIndex = newComments.findIndex((comment) => comment.id === commentId);
            // let tempComment = newComments[commentIndex];
            if (newComments[commentIndex].likeUsers) {
                newComments[commentIndex].likeUsers = [...newComments[commentIndex].likeUsers, { userID: getUserData().id }]
            } else {
                newComments[commentIndex].likeUsers = [{ userID: getUserData().id }]
            }

            // newComments[commentIndex]?.likeUsers?.push({ userID: getUserData().id });
            console.log("newComments", newComments);
            return newComments
        })
    }

    const onUnlike = (commentId: string) => {
        setComments((prevComments: any[]) => {
            let newComments = [...prevComments];
            let commentIndex = newComments.findIndex((comment) => comment.id === commentId);
            // let tempComment = newComments[commentIndex];
            if (newComments[commentIndex].likeUsers) {
                newComments[commentIndex].likeUsers = newComments[commentIndex].likeUsers.filter((user: any) => user.userID !== getUserData().id)
            } else {
                newComments[commentIndex].likeUsers = []
            }
            return newComments
        })
    }

    const onEditComment = (commentId: string) => {
        setCurrentCommentId(commentId);
        commentInputRef.current.focus();
    };

    const onCancelEditComment = () => {
        setCurrentCommentId("");
    };

    const updateEditedComment = (updatedComment: any) => {
        const index = comments.findIndex((comment: any) => {
            return comment?.id === updatedComment?.id;
        });

        if (index === -1) return;

        setComments((prev: any) => {
            prev?.splice(index, 1, updatedComment);
            return prev;
        });
    };

    const onDeleteComment = (commentId: any) => {
        setComments((prevComments: any[]) => {
            return prevComments.filter((comment) => comment.id !== commentId);
        });
    }

    const currentComment = useMemo(() => {
        return comments.find((comment: any) => comment.id === currentCommentId);
    }, [currentCommentId])

    return (
        <Drawer
            title="Comment"
            placement="right"
            // forceRender
            // mask={false}
            // destroyOnClose={true}
            width={489}
            onClose={props.onClose}
            open={props.open}
            headerStyle={{ borderBottom: 0, padding: "1.5rem "}}
            bodyStyle={{ paddingTop: "0"}}
        >
            <CommentToolbar
                contentStyle={{ paddingLeft: "0", paddingRight: "0", marginTop: "0", marginBottom: "1rem"}}
                ref={commentInputRef}
                id={props.feedId}
                webSocket={wsComment}
                onCommented={() => {

                }}
                isEditComment={currentCommentId}
                onCancelEditComment={onCancelEditComment}
                previousComment={currentComment}
                onEdited={updateEditedComment}
            />
            <List
                loading={loadCommentAPI.loading}
                className="comment-list"
                // header={`${data.length} replies`}
                itemLayout="horizontal"
                dataSource={comments}
                renderItem={comment => (
                    <li>
                        <Comment
                            id={comment.id}
                            data={comment}
                            imgURL={comment?.user?.imageProfileURL}
                            name={comment?.user?.firstname + (_.isEmpty(comment.user?.lastname) ? "" : " " + comment.user?.lastname)}
                            content={comment?.content}
                            likeUsers={comment?.likeUsers ? comment?.likeUsers : []}
                            isLike={comment?.likeUsers?.some((user: any) => user.userID === getUserData().id)}
                            date={comment?.updatedAt}
                            onLike={onLike}
                            onUnlike={onUnlike}
                            onEdit={onEditComment}
                            onDelete={onDeleteComment}
                        />
                        {/*<Comment*/}
                        {/*    // actions={item.actions}*/}
                        {/*    // author={item.author}*/}
                        {/*    avatar={<Avatar size={40} src={comment?.user?.imageProfileURL}/>}*/}
                        {/*    content={*/}
                        {/*        <Fragment>*/}
                        {/*            <div style={{*/}
                        {/*                padding: ".75rem 1.5rem",*/}
                        {/*                borderRadius: "20px",*/}
                        {/*                backgroundColor: "#F5F5F5"*/}
                        {/*            }}>*/}
                        {/*                <p style={{*/}
                        {/*                    fontWeight: "bold",*/}
                        {/*                    backgroundColor: "#F5F5F5",*/}
                        {/*                    marginBottom: ".75rem"*/}
                        {/*                }}>{comment.user?.firstname +*/}
                        {/*                    (_.isEmpty(comment.user?.lastname)*/}
                        {/*                        ? ""*/}
                        {/*                        : " " + comment.user?.lastname)}</p>*/}
                        {/*                <span>*/}
                        {/*                    {comment?.content}*/}
                        {/*                </span>*/}
                        {/*            </div>*/}
                        {/*            <div>*/}
                        {/*                <span style={{*/}
                        {/*                    fontSize: "12px",*/}
                        {/*                    color: "#BEBEBE"*/}
                        {/*                }}>{formatDate(comment?.createdAt)}</span>*/}
                        {/*            </div>*/}
                        {/*        </Fragment>*/}
                        {/*    }*/}
                        {/*    // datetime={item.datetime}*/}
                        {/*/>*/}
                    </li>
                )}
            />
        </Drawer>
    );
}